<section class="recommended-list-main-wrapper">
    <div class="recommended-list-border recommended-list-border-top"></div>
    <div class="recommended-list-title" *ngIf="showRecommendedList?.formId && totalSelectedItemList && !noData">
        <span class="title">{{showRecommendedList.title}}</span>
        <span>({{totalSelectedItemList.length}})</span>
        <span (click)="expandCollapseList()" class="expand-collapse" *ngIf="expandCollapseRequired">
            <i *ngIf="expandRecommendedList" _ngcontent-hka-c30="" class="icon__expand"></i>
            <i *ngIf="!expandRecommendedList" _ngcontent-hka-c30="" class="icon__collapse"></i>
        </span>
    </div>

    <section class="recommended-list-wrapper" *ngIf="showRecommendedList?.formId && totalSelectedItemList && !noData">
        <div class="recommended-list-table" *ngIf="expandRecommendedList">
            <gen-dynamic-form-table [tableTitle]=""
                                    [data]="recommendedListItems"
                                    [formId]="showRecommendedList?.formId"
                                    [formVertical]="true"
                                    [tableVertical]="true"
                                    [editMode]="true"
                                    [disabled] = "!permitItemSelectionWrite"
                                    [showAddButton]="false"
                                    [showDeleteButton]="true"
                                    [listenToDataChange]="true"
                                    (itemDeletedEmitter)="deleteItemHanlder($event)"
                                    [prioritizeAvailable]="prioritizeAvailable"
                                    [prioritizeTrackByField]="'decision'"
                                    (itemUpdateEmitter)="updateContainedData($event)"
            ></gen-dynamic-form-table>
        </div>
    </section>

<!-- <div class="recommended-list-border recommended-list-border-bottom"></div>-->
</section>